import { Constants, Enum } from '@examdojo/supabase';

export const TAG_COLORS = Constants.learning.Enums.tag_color;
export type TagColor = Enum<'tag_color', 'learning'>;

export interface Tag {
  id: string;
  name: string;
  color: TagColor;
  emoji: string | null;
  isSystem: boolean;
}
